var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "non-blocking-modal" }, [
    _c("div", { staticClass: "row mb-2" }, [
      _c("div", { staticClass: "col" }, [
        _c("h4", [_vm._v("Customer note")]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "l-modal-close",
            on: {
              click: function($event) {
                _vm.$emit("close")
              }
            }
          },
          [_vm._m(0)]
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row mb-2" }, [
      _c("div", { staticClass: "col" }, [
        _c("div", { staticClass: "select-wrap" }, [
          _c("label", [_vm._v("Note")]),
          _vm._v(" "),
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.customerNoteNew,
                expression: "customerNoteNew"
              }
            ],
            staticClass: "select-wrap-textarea form-control",
            attrs: {
              disabled:
                _vm.statusName === "Canceled" ||
                (_vm.statusName === "Completed" &&
                  !_vm.$_can("customers.notes.edit")) ||
                _vm.statusName === "Closed" ||
                _vm.statusName === "No Availability" ||
                _vm.statusName === "Booked",
              cols: "30",
              rows: "10"
            },
            domProps: { value: _vm.customerNoteNew },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.customerNoteNew = $event.target.value
              }
            }
          })
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col" },
        [_c("error-field", { attrs: { errors: _vm.errors, field: "note" } })],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }, [
        _vm.statusName !== "Canceled" &&
        (_vm.statusName !== "Completed" || _vm.$_can("customers.notes.edit")) &&
        _vm.statusName !== "Closed" &&
        _vm.statusName !== "No Availability" &&
        _vm.statusName !== "Booked"
          ? _c(
              "button",
              {
                staticClass: "btn btn-primary pull-right ld-ext-right",
                attrs: { type: "button", disabled: _vm.loading },
                on: { click: _vm.saveCustomerNote }
              },
              [
                _vm._v("\n        Save\n        "),
                _c("div", { staticClass: "ld ld-ball ld-flip" })
              ]
            )
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("button", { staticClass: "btn btn-close" }, [
      _c("span", { staticClass: "mod-icon-close opacity-50" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9959bdc0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9959bdc0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CustomerNote.vue
// module id = null
// module chunks = 